import { iAppState } from "../../interfaces/interfaces";
import { tAppAction, eAppActionTypes} from "./appTypes";

const initialState: iAppState = {
	userAddress: null,
	config: null,
	api: null,
	EOPTContract: null,
	tokens: [],
	systemTimestamp: null,
	// web3Provider: null,
	provider: null,
	isPro: false,
	tokensPrices: [],
	currentOptions: [],
	clientBalances: [],
	clientOrders: [],
	darkMode: true,
	clientHistory: {
		isUpdating: false,
		recordings: []
	},
	allOptions: [],
	optionsPeriod: 'all',
	KasAccessToken: null,
	chrNodeUrl: null,
}

export const appReducer = ( state = initialState, action: tAppAction) : iAppState => {
	switch (action.type){

		case eAppActionTypes.CLEAR_STATE:
			return {
				...initialState,
				isPro: state.isPro,
				darkMode: state.darkMode,
				config: state.config,	// otherwise causes errors
				api: state.api,
				systemTimestamp: state.systemTimestamp,
				tokensPrices: state.tokensPrices,
				KasAccessToken: state.KasAccessToken,
				tokens: state.tokens
			}
		;

		case eAppActionTypes.SET_USER_ADDRESS:
			return {...state, userAddress: action.payload}
		;

		case eAppActionTypes.SET_CONFIG:
			return {...state, config: action.payload}
		;

		case eAppActionTypes.SET_API:
			return {...state, api: action.payload}
		;

		case eAppActionTypes.SET_EOPT_CONTRACT:
			return {...state, EOPTContract: action.payload}
		;

		case eAppActionTypes.SET_TOKEN:
			// maybe add check if contract already exists
			let new_tokens = state.tokens.slice();
			new_tokens.push(action.payload);
			return {...state, tokens: new_tokens}
		;

		case eAppActionTypes.SET_SYSTEM_TIMESTAMP:
			return {...state, systemTimestamp: action.payload}
		;

		/* case eAppActionTypes.SET_WEB3_PROVIDER:
			return {...state, web3Provider: action.payload}
		; */

		case eAppActionTypes.SET_IS_PRO:
			return {...state, isPro: action.payload}
		;

		case eAppActionTypes.SET_TOKEN_PRICE:
			let new_token_prices = state.tokensPrices.slice();
			let token_price = new_token_prices.find( price => price.currency === action.payload.currency);
			if (token_price){
				token_price.price = action.payload.price;
			} else {
				new_token_prices.push(action.payload);
			}
			return {...state, tokensPrices: new_token_prices}
		;

		case eAppActionTypes.SET_CURRENT_OPTIONS:
			return {...state, currentOptions: action.payload}
		;

		case eAppActionTypes.SET_CLIENT_BALANCES:
			return {...state, clientBalances: action.payload}
		;

		case eAppActionTypes.SET_CLIENT_ORDERS:
			return {...state, clientOrders: action.payload}
		;

		case eAppActionTypes.SET_DARK_MODE:
			return {...state, darkMode: action.payload}
		;

		case eAppActionTypes.SET_IS_HISTORY_UPDATING:
			return {...state, clientHistory: {isUpdating: action.payload, recordings: state.clientHistory.recordings} }
		;

		case eAppActionTypes.SET_HISTORY_RECORDINGS:
			return {...state, clientHistory: {isUpdating: false, recordings: action.payload} }
		;

		case eAppActionTypes.SET_ALL_OPTIONS:
			return {...state, allOptions: action.payload}
		;

		case eAppActionTypes.SET_OPTIONS_PERIOD:
			return {...state, optionsPeriod: action.payload}
		;

		case eAppActionTypes.UPDATE_STRIKES:
			if (state.config){
				let config_copy = {...state.config};
				config_copy.strikes = action.payload;
				return {...state, config: config_copy};
			}
			return state
		;

		case eAppActionTypes.SET_KAS_ACCESS_TOKEN:
			return {...state, KasAccessToken: action.payload}
		;

		case eAppActionTypes.SET_CHR_NODE_URL:
            return { ...state, chrNodeUrl: action.payload }
		;

		default: return state;
	}
}